import { DataFieldType } from '~/enums/DataFieldType';
import { FieldModelConfigState } from '~/features/x-ray/fields/types';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { PromptModelConfigSuggestResponse } from '../../types/sylvanus/model';
import {
  mapFieldClassificationConfigAttributes,
  mapModelConfigAttributes,
} from './transformers';

interface Request {
  config: FieldModelConfigState;
  modelId: Uuid;
}

type Response = PromptModelConfigSuggestResponse;

const shouldIncludeSuggestTypeHints = (
  config: FieldModelConfigState,
): boolean => {
  if (config.fieldClassification) {
    return true;
  }

  const fieldType = config.field?.type;
  return fieldType !== undefined && fieldType !== DataFieldType.STRING;
};

export const suggestPromptModelInstructions = async ({
  config,
  modelId,
}: Request): Promise<Response | undefined> => {
  if (modelId !== 'new') {
    return sylvanus.get(`/model/${modelId}/config-suggest`);
  }

  const { field } = config;

  if (field) {
    const request = {
      field_name: field.label,
      instructions: config.instructions ?? '',
      ...(shouldIncludeSuggestTypeHints(config)
        ? {
            ...mapFieldClassificationConfigAttributes(config),
            ...mapModelConfigAttributes(config),
          }
        : {}),
    };

    return sylvanus.post('/model/config-suggest', request);
  }
};
